import * as React from 'react'
import {
    AuthenticatedTemplate,
    UnauthenticatedTemplate,
} from '@azure/msal-react'
import { useLocation, Redirect } from 'react-router-dom'
import { ApplicationShell } from '@components/intermix/ApplicationShell'
import { ISideNavContainer } from '@components/intermix/types'
import { sideNavConfig } from '@components/intermix/SideNavMenu'
import { useAppContext } from '@/AppContext'
import { useAppConfig } from '@/hooks/useAppConfig'

const Layout: React.FC<unknown> = props => {
    const { byPassAuth } = useAppConfig()
    const location = useLocation()
    const { navLinks, user } = useAppContext()
    const [navConfig, setNavConfig] = React.useState<ISideNavContainer>()

    React.useEffect(() => {
        if (navLinks) {
            setNavConfig({
                ...sideNavConfig,
                menu: {
                    ...sideNavConfig.menu,
                    links: navLinks,
                },
            })
        }
    }, [navLinks])
    return (
        <>
            {!byPassAuth && (
                <>
                    <UnauthenticatedTemplate>
                        <Redirect to="/login" />
                    </UnauthenticatedTemplate>
                    <AuthenticatedTemplate>
                        <ApplicationShell
                            sideNav={navConfig}
                            currentPath={location.pathname}
                            currentSearch={location.search}
                            hasNotifications
                        >
                            {user && props.children}
                        </ApplicationShell>
                    </AuthenticatedTemplate>
                </>
            )}
            {byPassAuth && (
                <ApplicationShell
                    sideNav={navConfig}
                    currentPath={location.pathname}
                    currentSearch={location.search}
                    hasNotifications
                >
                    {props.children}
                </ApplicationShell>
            )}
        </>
    )
}

export default React.memo(Layout)
